module.exports = __webpack_public_path__ + "img/product_127.ea15290.webp";